// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — counter.classic.js, новая — counter.cp.js
import { isCp } from 'libs/design';
import * as classic from './counter.classic';
import * as cp from './counter.cp';

export const Counter = isCp ? cp.Counter : classic.Counter;
